/**
 * Правила контактов. Никогда не строим ссылку на личный чат по числовому Telegram ID:
 * tg://user?id= работает не во всех клиентах и раскрывает идентификатор.
 */

/** Публичный username Telegram: 5–32 символа, латиница/цифры/_, начинается с буквы. */
const USERNAME_RE = /^[a-zA-Z][a-zA-Z0-9_]{3,30}[a-zA-Z0-9]$/;

export function isValidTelegramUsername(username: string | null | undefined): username is string {
  return typeof username === 'string' && USERNAME_RE.test(username) && !username.includes('__');
}

export function telegramProfileUrl(username: string): string | null {
  const clean = username.replace(/^@/, '');
  return isValidTelegramUsername(clean) ? `https://t.me/${clean}` : null;
}

/**
 * Нормализация узбекского номера в E.164: +998XXXXXXXXX (9 цифр после кода).
 * Принимает «+998 90 123-45-67», «998901234567», «90 123 45 67».
 * Возвращает null для некорректных номеров.
 */
export function normalizeUzPhone(input: string | null | undefined): string | null {
  if (!input) return null;
  const digits = input.replace(/\D/g, '');
  let national: string;
  if (digits.length === 12 && digits.startsWith('998')) national = digits.slice(3);
  else if (digits.length === 9) national = digits;
  else return null;
  // Код оператора/региона: первая цифра не 0.
  if (national.startsWith('0')) return null;
  return `+998${national}`;
}

export function formatUzPhone(e164: string): string {
  const m = /^\+998(\d{2})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  return m ? `+998 ${m[1]} ${m[2]}-${m[3]}-${m[4]}` : e164;
}

export interface ContactPreferences {
  showTelegramUsername: boolean;
  showPhone: boolean;
  phone: string | null;
  allowBotInquiries: boolean;
  /** Писать продавцу в чат приложения (по умолчанию разрешено). */
  allowChat?: boolean;
}

export interface SellerContactInfo {
  username: string | null;
  botStarted: boolean;
  botBlocked: boolean;
}

export interface PublicContactOptions {
  telegramUrl: string | null;
  phone: string | null;
  botInquiry: boolean;
  /** Можно написать в чат приложения (если чат включён на площадке). */
  chat: boolean;
}

/**
 * Какие способы связи показать покупателю. Учитывает только явно разрешённые продавцом.
 * Уведомление через бота возможно лишь если продавец запускал бота и не блокировал его.
 */
export function resolveContactOptions(prefs: ContactPreferences, seller: SellerContactInfo, chatEnabled = true): PublicContactOptions {
  const telegramUrl = prefs.showTelegramUsername && seller.username ? telegramProfileUrl(seller.username) : null;
  const phone = prefs.showPhone ? normalizeUzPhone(prefs.phone) : null;
  const botInquiry = prefs.allowBotInquiries && seller.botStarted && !seller.botBlocked;
  const chat = chatEnabled && prefs.allowChat !== false;
  return { telegramUrl, phone, botInquiry, chat };
}

export function hasAnyContact(o: PublicContactOptions): boolean {
  return Boolean(o.telegramUrl || o.phone || o.botInquiry || o.chat);
}
